// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { createAxios } from 'ts/createAxios';
import { GetICCardScanHistoryParams, ICCardScanHistories } from 'util/Types';
import { API_ENDPOINTS } from 'util/endPoints';
import { handleError } from 'util/errorHandler';

export const getICCardScanHistories = async (p: {
  params?: GetICCardScanHistoryParams;
  successCallback?: (data: ICCardScanHistories) => void;
}) => {
  const { params, successCallback } = p;
  const api = createAxios();

  try {
    const { data } = await api.get<ICCardScanHistories>(
      API_ENDPOINTS.SCAN_IC_CARD_HISTORIES,
      {
        params,
      }
    );

    if (data) {
      successCallback?.(data);
    }
  } catch (error) {
    handleError(error);
  }
};
